export default function PortalNotFound() {
  return (
    <main className="min-h-screen flex items-center justify-center px-6" style={{ background: "var(--senk-bg)", color: "var(--senk-fg)" }}>
      <div className="max-w-md text-center senk-rise">
        <p className="label-eyebrow">SENK DESIGN</p>
        <h1 className="font-serif-display text-5xl mt-4 leading-tight">Private studio portal.</h1>
        <p className="mt-6" style={{ color: "var(--senk-body)" }}>
          You need a project link from the studio to view a portal. If you&apos;re
          the studio, sign in below.
        </p>
        <a href="/admin" className="btn-primary btn-type mt-10" data-testid="home-admin-link">
          <span>Studio Access</span>
        </a>
      </div>
    </main>
  );
}
